import { HTMLProps } from 'react';

import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Button } from './Button';

export const Dropzone: React.FC<{
    text?: string,
    dragText?: string,
    btn: string,
    ondrop: (_: File[]) => void
} & HTMLProps<HTMLDivElement>> = ({ text, dragText, btn, className, ondrop }) => {
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop: ondrop, accept: '.xml' });

    return (
        <div
            {...getRootProps()}
            className={`bg-opacity-10 rounded-2xl border-dashed border-bnd-black-1 border p-10 ${className}`}
        >
            <input {...getInputProps()} />
            {isDragActive ? (
                <div className="my-8 flex flex-1 h-full justify-center items-center">{dragText}</div>
            ) : (
                <div className="flex flex-col flex-1 h-full justify-around items-center">
                    {!!text && <span>{text}</span>}
                    <Button 
                        tint="green"
                        size="sm"
                        className="font-bold mt-4 px-8"
                    >
                        {btn}
                    </Button>
                </div>)}
        </div>
    );
};